import {
  FETCH_SUBSIDY_START,
  FETCH_SUBSIDY_MORE_START,
  FETCH_SUBSIDY_SUCCESS,
  FETCH_SUBSIDY_FAILED,
  SUBMIT_SUBSIDY_START,
  SUBMIT_SUBSIDY_SUCCESS,
  SUBMIT_SUBSIDY_FAILED,
  DELETE_SUBSIDY_START,
  DELETE_SUBSIDY_SUCCESS,
  DELETE_SUBSIDY_FAILED,
  CLEAR_SUBSIDY_MESSAGE,
} from './actions';

const initialState = {
  activeData: null,
  historyList: [],
  isLoading: false,
  isLoadMoreLoading: false,
  isSubmitLoading: false,
  isDeleteLoading: false,
  meta: {
    page: 1,
    totalData: 0,
    totalPage: 1,
  },
  message: '',
  error: '',
  successSubmit: false,
  successDelete: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SUBSIDY_START:
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    case FETCH_SUBSIDY_MORE_START:
      return {
        ...state,
        isLoadMoreLoading: true,
      };
    case FETCH_SUBSIDY_SUCCESS: {
      const payload = action.payload || {};
      const rawSummary = payload.summary || payload.activeData || payload.active ||
        (Array.isArray(payload) ? payload.find((i) => i.status === 'ACTIVE') : null);
      const summary = (rawSummary && (rawSummary.id || rawSummary.status || rawSummary.startDate))
        ? rawSummary
        : null;
      const newHistory = payload.history || payload.historyList ||
        (Array.isArray(payload) ? payload : []);
      const meta = payload.meta || action.meta || {
        page: 1,
        totalData: newHistory.length,
        totalPage: 1,
      };
      const historyList = action.isLoadMore
        ? [...state.historyList, ...newHistory]
        : newHistory;
      return {
        ...state,
        isLoading: false,
        isLoadMoreLoading: false,
        activeData: summary || state.activeData,
        historyList,
        meta,
      };
    }
    case FETCH_SUBSIDY_FAILED:
      return {
        ...state,
        isLoading: false,
        isLoadMoreLoading: false,
        error: action.payload,
      };
    case SUBMIT_SUBSIDY_START:
      return {
        ...state,
        isSubmitLoading: true,
        message: '',
        error: '',
        successSubmit: false,
      };
    case SUBMIT_SUBSIDY_SUCCESS:
      return {
        ...state,
        isSubmitLoading: false,
        message: action.payload,
        successSubmit: true,
      };
    case SUBMIT_SUBSIDY_FAILED:
      return {
        ...state,
        isSubmitLoading: false,
        error: action.payload,
        successSubmit: false,
      };
    case DELETE_SUBSIDY_START:
      return {
        ...state,
        isDeleteLoading: true,
        message: '',
        error: '',
        successDelete: false,
      };
    case DELETE_SUBSIDY_SUCCESS:
      return {
        ...state,
        isDeleteLoading: false,
        message: action.payload,
        successDelete: true,
      };
    case DELETE_SUBSIDY_FAILED:
      return {
        ...state,
        isDeleteLoading: false,
        error: action.payload,
        successDelete: false,
      };
    case CLEAR_SUBSIDY_MESSAGE:
      return {
        ...state,
        message: '',
        error: '',
        successSubmit: false,
        successDelete: false,
      };
    default:
      return state;
  }
}
